<template>
  <div>
    <div v-if="blok.description.content[0]?.content" class="description" v-html="useRenderRichText(blok.description)"></div>
    <template v-if="blok.type == 'text'">
      <FormInput
        :id="prefixId(blok.id)"
        :name="blok.id"
        :label="blok.label"
        type="text"
        :rules="blok.required ? 'required' : null"
        :required="blok.required"
        :is-myself="isMyself"
        :max-length="limitInputs ?? '50'"
      />
    </template>
    <template v-else-if="blok.type == 'slot-picker'">
      <FormSlotPicker
        :id="prefixId(blok.id)"
        :name="blok.id"
        :label="blok.label"
        :rules="blok.required ? 'required' : null"
        :required="blok.required"
        :options="blok"
        @is-disabled-submit="emitDisabled()"
        @is-enabled-submit="emitEnabled()"
      />
    </template>
    <template v-else-if="blok.type == 'datetime'">
      <FormInput
        :id="prefixId(blok.id)"
        :name="blok.id"
        :label="blok.label"
        :type="isDesktop ? 'text' : 'datetime-local'"
        focused-type="datetime-local"
        :rules="blok.required ? 'required' : null"
        :required="blok.required"
      />
    </template>
    <template v-else-if="blok.type == 'date'">
      <FormInput
        :id="prefixId(blok.id)"
        :name="blok.id"
        :label="blok.label"
        :type="isDesktop ? 'text' : 'date'"
        focused-type="date"
        :rules="blok.required ? 'required' : null"
        :required="blok.required"
      />
    </template>
    <template v-else-if="blok.type == 'time'">
      <FormInput
        :id="prefixId(blok.id)"
        :name="blok.id"
        :label="blok.label"
        :type="isDesktop ? 'text' : 'time'"
        focused-type="time"
        :rules="blok.required ? 'required' : null"
        :required="blok.required"
      />
    </template>
    <template v-else-if="blok.type == 'tel'">
      <FormInput
        :id="prefixId(blok.id)"
        :name="blok.id"
        :label="blok.label"
        type="tel"
        :required="blok.required"
      />
    </template>
    <template v-else-if="blok.type == 'email'">
      <FormInput
        :id="prefixId(blok.id)"
        :name="blok.id"
        :label="blok.label"
        type="email"
        :required="blok.required"
      />
    </template>
    <template v-else-if="blok.type == 'textarea'">
      <FormTextarea
        :id="prefixId(blok.id)"
        :name="blok.id"
        :label="blok.label"
        :required="blok.required"
        rows="4"
      />
    </template>
    <template v-else-if="blok.type == 'privacy'">
      <FormCheckbox
        :id="prefixId(blok.id)"
        :name="blok.id"
        :label="`${useRenderRichText(blok.label_privacy)} *`"
        required
      />
    </template>
    <template v-else-if="blok.type == 'radio'">
      <FormRadio
        :id="blok.id"
        :options="blok.options"
        :label="blok.label"
        :required="blok.required"
        @is-myself="emitMyself"
      />
    </template>
    <template v-else-if="blok.type == 'checkbox'">
      <template v-if="blok.multiple_choices">
        <FormCheckboxGroup
          :id="blok.id"
          :options="blok.options"
          :label="blok.label"
          :required="blok.required"
        />
      </template>
      <template v-else>
        <FormCheckbox
          :id="prefixId(blok.id)"
          :name="blok.id"
          :label="`${blok.label}${blok.required ? ' *' : ''}`"
          :required="blok.required"
        />
      </template>
    </template>
    <template v-else-if="blok.type == 'select'">
      <FormSelect
        v-if="blok.options?.length > 0"
        :id="prefixId(blok.id)"
        :name="blok.id"
        :label="blok.label"
        :options="blok.options"
        :required="blok.required"
        :is-form-builder="true"
        :is-myself="isMyself"
        :updated-value="updatedValue"
        @select-val="emitSelectVal"
      />
    </template>
    <template v-else-if="blok.type == 'hidden'">
      <FormInput
        :id="prefixId(blok.id)"
        :name="blok.id"
        type="hidden"
        :value="blok.value"
      />
    </template>
  </div>
</template>

<script setup>
import { v4 as uuidv4 } from "uuid";

const props = defineProps({
  blok: {
    type: Object,
    required: true,
  },
  isMyself: {
    type: Boolean,
    required: false,
    default: false,
  },
  updatedValue: {
    type: Array,
    required: false,
    default: () => {
      return [];
    },
  },
});
const isDesktop = inject("isDesktop");
const uuid = ref(uuidv4());
const limitInputs = await useLimitInputField();

const prefixId = (value) => {
  return `${uuid.value}-${value}`;
};

const emit = defineEmits(["isDisabledSubmit", "isEnabledSubmit", "isMyself", "selectVal"]);
const emitDisabled = () => {
  emit("isDisabledSubmit");
}
const emitEnabled = () => {
  emit("isEnabledSubmit");
}
const emitMyself = (value) => {
  emit("isMyself", value);
}
const emitSelectVal = (value) => {
  emit("selectValue", value);
}
</script>

<style lang="scss" scoped>
.description {
  margin-top: 2rem;
  margin-bottom: 0.625rem;
}
</style>
